<template>
  <div class="card" v-show="currentCardId == 'hobby'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>趣味・特技を入力</h2>
        <p>{{ hobbyLabel }}</p>
      </div>
      <div class="add-item">
        <el-button type="success" @click="exampleVisible = true"
          >例文から追加</el-button
        >
      </div>
      <div class="card-content">
        <NewRirekishoExampleSentenceDialog
          :value="exampleVisible"
          name="hobby-dialog"
          :items="hobbyExamples"
          show-overwrite-warning
          @input="exampleVisible = $event"
          @select="onSelectExample"
        />
        <el-input
          type="textarea"
          v-model="formatData.hobby"
          :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
        />
        <div class="attention-limit character" v-if="previewErrors.hobby">
          <i class="el-icon-warning"></i>
          入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import NewRirekishoExampleSentenceDialog from '@/components/format-edit/new-rirekisho/NewRirekishoExampleSentenceDialog.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentence,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'

const hobbyLabel = '人柄も大切。趣味・特技であなたの個性をアピールしましょう！'

const props = defineProps<{
  currentCardId?: string
  exampleSentences?: RirekishoExampleSentences
  textareaMinRows: number
  previewErrors: Record<string, string>
}>()

const formatData = useRirekishoFormatData()
const exampleVisible = ref(false)

const hobbyExamples = computed(() => props.exampleSentences?.hobby || [])

function onSelectExample(item: RirekishoExampleSentence) {
  formatData.hobby += item.description.replace(/<br>/gi, '\n') + '\n'
}
</script>
